import api from "./axios-setup/axios";

/**
 * Get details of a specific call
 * @param {string} callSid - Call SID (e.g., CA1234567890abcdef1234567890abcdef)
 * @returns {Promise<object>} Call details
 */
export const getSpecificCall = async (callSid) => {
  const response = await api.get(`/twilio/api/calls/${callSid}`);
  return response.data;
};

/**
 * Get all recordings for a specific call
 * @param {string} callSid - Call SID
 * @returns {Promise<object[]>} Array of recordings
 */
export const getCallRecordings = async (callSid) => {
  const response = await api.get(`/twilio/api/calls/${callSid}/recordings`);
  return response.data;
};

/**
 * Get details of a specific recording
 * @param {string} recordingSid - Recording SID (e.g., RE1234567890abcdef1234567890abcde)
 * @returns {Promise<object>} Recording details
 */
export const getSpecificRecording = async (recordingSid) => {
  const response = await api.get(`/twilio/api/recordings/${recordingSid}`);
  return response.data;
};

/**
 * Download a specific recording
 * @param {string} recordingSid - Recording SID
 * @returns {Promise<Blob|object>} Recording file or response object
 */
export const downloadRecording = async (recordingSid) => {
  const response = await api.get(
    `/twilio/api/recordings/${recordingSid}/download`,
    {
      responseType: "blob", // ensures binary file is returned
    },
  );
  return response.data;
};

/**
 * Get Twilio usage statistics for a date range
 * @param {string} startDate - Start date in YYYY-MM-DD format
 * @param {string} endDate - End date in YYYY-MM-DD format
 * @returns {Promise<object>} Usage statistics
 */
export const getUsageStatistics = async (startDate, endDate) => {
  const response = await api.get("/twilio/api/usage", {
    params: { start_date: startDate, end_date: endDate },
  });
  return response.data;
};

/**
 * List all call logs with pagination
 * @param {number} [page=1] - Page number
 * @param {number} [page_size=10] - Records per page
 * @returns {Promise<object[]>} Array of call logs
 */
export const listAllCallLogs = async (page = 1, page_size = 10) => {
  const response = await api.get("/twilio/call-logs", {
    params: { page, page_size },
  });
  return response.data;
};

/**
 * Get Twilio call statistics for a date range
 * @param {string} startDate - Start date in YYYY-MM-DD format
 * @param {string} endDate - End date in YYYY-MM-DD format
 * @returns {Promise<object>} Call statistics
 */
export const getCallStatistics = async (startDate, endDate) => {
  const response = await api.get("/twilio/api/statistics", {
    params: { start_date: startDate, end_date: endDate },
  });
  return response.data;
};

// Get all available filters
export const getAvailableFilters = async () => {
  const response = await api.get("/twilio/stats/filters/calls");
  return response.data;
};

// Get Filtered Calls
export const getFilteredCalls = async (limit = 1000, filters = []) => {
  const payload = { filters, limit };

  const response = await api.post("/twilio/stats/calls", payload);
  return response.data;
};
